import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => ({
        id: item.key,
        name: item.name,
        iconName: item.icon,
        url: item.url,
        description: item.description,
        disabled: item.disabled,
        productionReady: item.productionReady,
      })),
};

const operationURLS = {
  list: "/departmentDetails/list",
  pdfDownload: "/departmentDetails/generateAndDownloadPdf",
  csvDownload: "/departmentDetails/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Department Code",
      accessor: "departmentCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Department Name",
      accessor: "departmentName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Caller Number",
      accessor: "callerIdNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Caller Name",
      accessor: "callerName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Destination Number",
      accessor: "destinationNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Destination Name",
      accessor: "destinationName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Call Type",
      accessor: "callType",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Call Date",
      accessor: "startEpoch",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "date",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Call Direction",
      accessor: "coralCallDirection",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Talk Time",
      accessor: "talkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Pulse",
      accessor: "pulse",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Cost(INR)",
      accessor: "cost",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
